import React, { useEffect, useMemo } from 'react';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';
import { Spinner, ToastManager as IMToastManager } from '@insurancemenu/imenu-components-lib';
import ScrollToTop from 'global/hooks/ScrollToTop';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from 'components/common/general/Header';
import Footer from 'components/common/general/Footer';
import BrowseInfoPage from 'pages/BrowseInfoPage';
import RateSegmentsPage from 'pages/RateSegmentsPage';
import Error404Page from 'pages/Error404Page';
import PopularPlansPage from 'pages/PopularPlansPage';
import ComparePortfoliosPage from 'pages/ComparePortfoliosPage';
import BrowsingPage from 'pages/BrowsingPage';
import CartPage from 'pages/CartPage';
import HelpMeDecidePage from 'pages/HelpMeDecidePage';
import { createThemeContext, ThemeContext } from '@insurancemenu/imenu-components-lib/dist/hooks/useTheme';
import { createStyles } from './globalStyles';

const App: React.FC = observer(() => {
  const classes = createStyles();

  // Mobx store
  const {
    domainStore: { loading, getDomainByOrigin, domainHeader },
  } = useRootStore();

  const themeContextValue = useMemo(() => {
    return createThemeContext(domainHeader.headerStyleId);
  }, [domainHeader.headerStyleId]);

  // Show the cart icon in the menu on all pages except the first one
  // The cart is created after submitting the form on the first page
  useEffect(() => {
    void getDomainByOrigin(window.location.origin);
  }, []);

  return (
    <ThemeContext.Provider value={themeContextValue}>
      {loading ? (
        <div className={classes.spinnerWrapper}>
          <Spinner />
        </div>
      ) : (
        <div className={classes.appWrapper}>
          <Router>
            <Header />
            <ScrollToTop>
              <Switch>
                <Route exact path="/browse-info" component={BrowseInfoPage} />
                <Route exact path="/rate-segments" component={RateSegmentsPage} />
                <Route exact path="/popular-plans" component={PopularPlansPage} />
                <Route exact path="/product-compare" component={ComparePortfoliosPage} />
                <Route exact path="/browsing" component={BrowsingPage} />
                <Route exact path="/cart" component={CartPage} />
                <Route exact path="/help-me-decide" component={HelpMeDecidePage} />
                <Route exact path="/error-404" component={Error404Page} />
                <Route exact path="/">
                  <Redirect to="/browse-info" />
                </Route>
                <Route exact path="*">
                  <Redirect to="/error-404" />
                </Route>
              </Switch>
            </ScrollToTop>
          </Router>
          <Footer />
        </div>
      )}

      <ToastContainer />
      <IMToastManager />
    </ThemeContext.Provider>
  );
});

export default App;
